import { get, isEmpty } from 'lodash'
import React from 'react'

export default function useFetchList(cached = [], fetching, companyAtr = 'company') {
  const [company, setCompany] = React.useState()
  const [list, setList] = React.useState(() => cached)

  function onChangeCompany(company) {
    if (isEmpty(company)) {
      setList(cached)
      setCompany(company)
    } else {
      setList(cached.filter((i) => get(i, companyAtr + '._id') === company))
      setCompany(company)
    }
  }

  React.useEffect(() => {
    if (!company) {
      setList(cached)
    } else {
      onChangeCompany(company)
    }
  }, [fetching])

  return {
    list,
    company,
    onChangeCompany,
  }
}
